import React from 'react';
import { MCButton, View } from '../basic';
import LANG_CONST from 'src/helpers/lang/const';
import { lang, remCss } from 'src/helpers';
import SVGIcon, { BASE_ICONS } from '../svg';
import appModel from '../../model';
import config from 'src/config';

export const GoogleButtonContainer = ({ loading, isLogin, role }) => {
  return (
    <View style={{ gap: remCss(15) }}>
      <MCButton
        large
        primary
        radius
        outline
        disabled={loading}
        type={'button'}
        onClick={(e) => {
          e.preventDefault();
          const searchParams = new URLSearchParams(window.location.search);
          appModel.setStateSilent({
            signupData: {
              role,
              clinicUsername: searchParams.has('clinicUsername')
                ? searchParams.get('clinicUsername')
                : null,
              inviteCode: searchParams.has('code') ? searchParams.get('code') : null
            }
          });
          window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${new URLSearchParams(
            config.get('googleAuth')
          )}`;
        }}
      >
        <SVGIcon
          iconname={BASE_ICONS.GOOGLE}
          width={isLogin ? 30 : 40}
          padding={isLogin ? 15 : 27}
        />
        <span style={{ paddingRight: remCss(isLogin ? 36 : 46) }}>
          {lang.t(LANG_CONST.buttons.continue_with_google)}
        </span>
      </MCButton>
      <div className='mc-divider'>{lang.t(LANG_CONST.or).toUpperCase()}</div>
    </View>
  );
};
